import _Map from "@babel/runtime-corejs3/core-js/map";
var resCodeMap = new _Map([[0, 'onSuccess'], [-1, 'onCancel'], [-2, 'onFail'], [-3, 'onProgress'], [-4, 'onSubmit']]);
function electronResCodeMap(code) {
  return resCodeMap.get(code) || 'onFail';
}
export { electronResCodeMap };


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/lib/helper/codeMap.js
// module id = null
// module chunks = 